module.exports = __webpack_public_path__ + "static/media/logo.e60621a3.png";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/kmcAssets/img/logo.png
// module id = 3396
// module chunks = 1137